export const ANNOUNCEMENTS = {
	ANNOUNCEMENTS: "Announcements",
	NO_ANNOUNCEMENTS: "No announcements available"
}
